import { useContext, useState } from 'react';

import { FormStepContext } from './FormStepContext';

const allowedFileExtensions = [
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'application/msword',
  'application/xlsx',
  'application/rtf',
  'application/odt',
  'application/bpmn',
  'text/plain',
  'text/csv',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/webp',
];

const UploadedFile = () => {
  const { uploadedFile, setUploadedFile } = useContext(FormStepContext);
  const [isFilesLimited, setFilesLimited] = useState(false);
  const [isMaxSize, setMaxSize] = useState(false);
  const MAX_FILE_SIZE = 5000000;
  const MAX_FILES_COUNT = 1;

  const validateFile = (type) => {
    return allowedFileExtensions.indexOf(type) !== -1;
  };

  const isAllowedFile = (fileName) => {
    return /\.(rtf|odt|bpmn)$/i.test(fileName);
  };

  const handleAddFile = (e) => {
    if (e.target.files.length > MAX_FILES_COUNT) setFilesLimited(true);

    const file = e.target.files[0];

    if (isMaxSize) setMaxSize(false);
    const filesSize = file.size;

    if (e.target.files.length === MAX_FILES_COUNT) {
      if (isAllowedFile(file.name) || validateFile(file.type)) {
        if (filesSize <= MAX_FILE_SIZE) setUploadedFile(file);
      }
    }

    if (filesSize > MAX_FILE_SIZE) setMaxSize(true);
  };

  const handleRemoveFile = () => {
    if (isFilesLimited) setFilesLimited(false);
    if (isMaxSize) setMaxSize(false);
    setUploadedFile({});
  };

  const getExtension = (fileName) => fileName.split('.').pop().toLowerCase();
  const getFileName = (fileName) => fileName.split('.')[0];

  return (
    <div className="attached-file__block">
      {!uploadedFile.name && (
        <div className="attached-file__label-wrapper">
          <label className="attached-file__label">
            <input
              type="file"
              accept="image/png,image/jpg,image/jpeg,image/webp,.svg,.bpmn,.pdf,.doc,.docx,application/msword,.txt,.csv,.xlsx,.rtf,.odt"
              name="file"
              onChange={handleAddFile}
              multiple={false}
              className="attached-file__input"
            />
            <span>Attach a file</span>
          </label>
          <p>.pdf, .doc, .docx. Max file size 5MB.</p>
        </div>
      )}
      {uploadedFile.name && (
        <div className="attached-file__file">
          <div className="file ic-doc-text">
            <span className="attached-file__name">
              {getFileName(uploadedFile.name)}
            </span>
            <span className="attached-file__ext">
              .{getExtension(uploadedFile.name)}
            </span>
            <button
              type="button"
              className="attached-file__btn-delete ic-close-square"
              title="Delete"
              aria-label="Delete"
              onClick={handleRemoveFile}
            />
          </div>
        </div>
      )}
      {/* Warning about the number of files or file size */}
      {isFilesLimited && <p className="error">Only 1 file could be added</p>}
      {isMaxSize && <p className="error">Max files size, 5MB</p>}
    </div>
  );
};

export default UploadedFile;
